import client from './client';

export const getPageSolutionAirData = async () => {
  try { 
      const response = await client.get( "/api/page-air?populate[page_air][populate]=image" )
      //console.log("API Response getPageSolutionAirData: ", response.data.data);
      return response.data.data;
  } catch (error) {
      if (error.response) {
          console.error('API Error:', error.response.data);
      } else if (error.request) {
          console.error('No response from server:', error.request); // Problema de conexión
      } else {
          console.error('Error configurando la solicitud:', error.message); // Otro error
      }
      throw error;
  }
} 
export const getPageSolutionHotelData = async () => {
  try { 
      const response = await client.get( "/api/page-hotel?populate[page_hotel][populate]=image" )
      return response.data.data;
  } catch (error) {
      if (error.response) {
          console.error('API Error:', error.response.data);
      } else if (error.request) {
          console.error('No response from server:', error.request); // Problema de conexión
      } else {
          console.error('Error configurando la solicitud:', error.message); // Otro error
      }
      throw error;
  }
} 
export const getPageSolutionAssistData = async () => {
  try { 
      const response = await client.get(  "/api/page-assist?populate[page_assist][populate]=image" )
      return response.data.data;
  } catch (error) {
      if (error.response) {
          console.error('API Error:', error.response.data);
      } else if (error.request) {
          console.error('No response from server:', error.request); // Problema de conexión
      } else {
          console.error('Error configurando la solicitud:', error.message); // Otro error
      }
      throw error;
  }
} 
export const getPageSolutionTrainData = async () => {
  try { 
      const response = await client.get(  "/api/page-train?populate[page_train][populate]=image"  )
      return response.data.data;
  } catch (error) {
      if (error.response) {
          console.error('API Error:', error.response.data);
      } else if (error.request) {
          console.error('No response from server:', error.request); // Problema de conexión
      } else {
          console.error('Error configurando la solicitud:', error.message); // Otro error
      }
      throw error;
  }
} 
export const getPageSolutionPackageData = async () => {
  try { 
      const response = await client.get(  "/api/page-package?populate[page_package][populate]=image"  )
      return response.data.data;
  } catch (error) {
      if (error.response) {
          console.error('API Error:', error.response.data);
      } else if (error.request) {
          console.error('No response from server:', error.request); // Problema de conexión
      } else {
          console.error('Error configurando la solicitud:', error.message); // Otro error
      }
      throw error;
  }
} 
export const getPageSolutionAutomationsData = async () => {
  try { 
      const response = await client.get(  "/api/page-automation?populate[page_automation][populate]=image"  )
      return response.data.data;
  } catch (error) {
      if (error.response) {
          console.error('API Error:', error.response.data);
      } else if (error.request) {
          console.error('No response from server:', error.request); // Problema de conexión
      } else {
          console.error('Error configurando la solicitud:', error.message); // Otro error
      }
      throw error;
  }
} 
export const getPageSolutionDiscoveriesData = async () => {
  try { 
      const response = await client.get(  "/api/page-discovery?populate[page_discovery][populate]=image"  )
      return response.data.data;
  } catch (error) {
      if (error.response) {
          console.error('API Error:', error.response.data);
      } else if (error.request) {
          console.error('No response from server:', error.request); // Problema de conexión
      } else {
          console.error('Error configurando la solicitud:', error.message); // Otro error
      }
      throw error;
  }
} 